import SignIn from '../../services/auth.service'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import SessionStorage from '../../util/sessionstore'
import { message } from 'antd'

const session = new SessionStorage()

/*
Actions to be dispatched for signin
- login
    async thunk action which checks for valid login
- loginError
    action to dispatch incase of login error
- operationInProgress
    action to dispatch incase of login operation in progress
- loginSuccess
    action to dispatch incase of sucessfull login
- logout
    action to log out of the system
*/
export function loginError(bool, message) {
  return {
    type: ActionType.LOGIN_ERROR,
    hasError: bool,
    message,
    isLoading: false,
  }
}

export function resetError(bool, message) {
  return {
    type: ActionType.PASSWORD_ERROR,
    resetError: bool,
    message,
    isLoading: false,
  }
}

export function resetSuccess(successMessage) {
  return {
    type: ActionType.RESET_SUCCESS,
    successMessage,
    isLoading: false,
  }
}

export function operationInProgress(bool) {
  return {
    type: ActionType.OPERATION_INPROGRESS,
    isLoading: bool,
  }
}

export function loginSuccess({ token, customer, user, company }) {
  return {
    type: ActionType.LOGIN_SUCCESS,
    isLoading: false,
    token,
    customer,
    user,
    company,
  }
}

export function setFilter(filters) {
  return {
    type: ActionType.SET_FILTER,
    filters,
  }
}

export function logout() {
  session.removeAll()
  return {
    type: ActionType.LOGOUT,
    hasError: false,
    isLoading: false,
    token: null,
    user: [],
    customer: [],
  }
}

export function updateUser(user) {
  return {
    type: ActionType.UPDATE_USER,
    user,
  }
}

export function loginAsCustomer(customer) {
  return (dispatch, getState) => {
    // Callers pass whatever `customer` their own query happened to select, and
    // several select a thin subset (object literals, or queries that omit
    // accesscode). Because this replaces the store's customer wholesale, one
    // thin dispatch silently strips fields other screens depend on — the clinic
    // code vanishing from the header after opening a patient was exactly this.
    //
    // Merge ONLY when it is the same clinic. Never merge across a switch: that
    // would carry one clinic's accesscode onto another, which is worse than the
    // bug it fixes. A different clinic (or none) replaces outright, as before.
    const prev = getState().profile && getState().profile.customer
    const sameClinic =
      prev && customer && prev._id && String(prev._id) === String(customer._id)
    const merged = sameClinic ? { ...prev, ...customer } : customer

    // Persist the selected customer so the scope survives a full page reload
    // (the Redux store is rebuilt from sessionStorage on Ctrl+R).
    session.updateCustomer(merged)
    return dispatch({
      type: ActionType.LOGIN_AS_CUSTOMER,
      customer: merged,
    })
  }
}

export function loginAsCompany(company) {
  return (dispatch) => {
    // Switching back to the company view clears the selected clinic. Clear it
    // in sessionStorage too, otherwise a hard reload rebuilds the store with
    // the stale customer and the header renders the clinic nav on /cases.
    session.updateCustomer(null)
    return dispatch({
      type: ActionType.LOGIN_AS_COMPANY,
      company,
    })
  }
}

export function setSurgeryTypes(types) {
  return {
    type: ActionType.SET_SURGERY_TYPES,
    types,
  }
}

export function resetPassword(oldPassword, newPassword) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .resetPassword(oldPassword, newPassword)
      dispatch(operationInProgress(false))
      if (data.error) dispatch(resetError(true, data.message))
      else dispatch(resetSuccess('Password changed'))
    } catch (err) {
      dispatch(resetError(true, 'error communicating with the server'))
    }
  }
}
export function deleteUserDeviceToken() {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .deleteUserDeviceToken()
      dispatch(operationInProgress(false))
    } catch (err) {
      dispatch(resetError(true, 'error communicating with the server'))
    }
  }
}
export function login(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.AuthService().login(input)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        dispatch(loginError(true, data.message))
        // Return the failure rather than undefined, so the caller can read
        // `captcha_required` and show the Turnstile widget. It carries
        // `error: true`, and signin.js checks that before navigating —
        // returning a truthy value here previously would have sent a FAILED
        // login on to the OTP screen. Added 2026-09-04 with Gate 9 S7.
        return data
      } else {
        dispatch(loginSuccess(data))
        dispatch(setFilter(data.user.filter))
        return data;
      }
    } catch (err) {
      dispatch(loginError(true, 'error communicating with the server'))
    }
  }
}

export function loginWithOtp(otp) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.AuthService().loginWithOtp(otp)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        //dispatch(loginError(true, data.message));
      } else {
        dispatch(loginSuccess(data))
        dispatch(setFilter(data.user.filter))
        return data;
      }
    } catch (err) {
      dispatch(loginError(true, 'error communicating with the server'))
    }
  }
}

export function resendOtp(otp) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.AuthService().resendOtp(otp)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        //dispatch(loginError(true, data.message));
      } else {
        dispatch(loginSuccess(data))
        dispatch(setFilter(data.user.filter))
        message.success(data.message)
      }
    } catch (err) {
      dispatch(loginError(true, 'error communicating with the server'))
    }
  }
}

export function getAllSurgeryTypes() {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.SurgeryService().getAllSurgeryTypes()
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        dispatch(loginError(true, data.message))
      } else dispatch(setSurgeryTypes(data.types))
    } catch (err) {
      dispatch(loginError(true, 'error communicating with the server'))
    }
  }
}

export function switchEventAutoImport(params, flag) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .EventService()
        .switchEventAutoImport(params, flag)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
      } else {
        return data
      }
    } catch (err) {
      dispatch(loginError(true, 'error communicating with the server'))
    }
  }
}
